<div class="flex flex-col gap-6">
  <div class="flex flex-col items-start gap-1">
    <h1 class="textPrimaryColor text-2xl font-bold" i18n="@@statementAccountTitle">كشف الحساب</h1>
  </div>

  <div class="rounded-2xl bg-white p-8 shadow-sm">
    <div class="flex flex-col items-start gap-4">
      <h2 class="textPrimaryColor text-[18px] font-bold" i18n="@@selectPharmacyTitle">اختر الصيدلية</h2>

      <div class="relative flex w-full flex-col items-start gap-2 md:w-[55%]">
        <label class="flex items-center gap-1 text-[14px] font-bold">
          <span i18n="@@pharmacyLabel">الصيدلية</span>
          <span class="textPrimaryColor">*</span>
        </label>
        <div class="relative w-full">
          <input
            type="text"
            [formControl]="searchControl"
            placeholder="ادخل اسم الصيدلية"
            i18n-placeholder="@@searchPharmacyPlaceholder"
            class="focus:textTabsColor focus:textTabsColor w-full rounded-[10px] border border-gray-300 bg-white py-3 pr-10 pl-4 text-right text-[14px] text-gray-800 transition-colors outline-none focus:ring-1"
            (focus)="onSearchFocus()" />

          <div class="pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 text-gray-400">
            <app-search-icon></app-search-icon>
          </div>

          @if (showDropdown()) {
            <div
              class="absolute top-[calc(100%+6px)] right-0 z-50 flex max-h-[280px] w-full flex-col overflow-y-auto rounded-[10px] border border-gray-200 bg-white shadow-lg">
              @if (isLoading()) {
                <div class="p-4 text-center text-[13px] text-gray-500" i18n="@@searchingText">جاري البحث...</div>
              } @else if (!isLoading() && pharmaciesList().length === 0 && searchControl.value.trim().length >= 2) {
                <div class="p-4 text-center text-[13px] text-gray-500" i18n="@@noPharmacyFound">
                  لا توجد نتائج مطابقة
                </div>
              } @else {
                @for (item of pharmaciesList(); track item.id) {
                  <div
                    (click)="selectPharmacy(item)"
                    class="flex cursor-pointer items-center gap-5 border-b border-gray-100 p-4 transition-colors last:border-0 hover:bg-gray-50"
                    [class.bgSelectedColor]="selectedPharmacy()?.id === item.id">
                    <div class="ml-3 shrink-0">
                      @if (selectedPharmacy()?.id === item.id) {
                        <div class="bgGreenColor flex h-6 w-6 items-center justify-center rounded-full">
                          <app-auto-complete-confirm-icon></app-auto-complete-confirm-icon>
                        </div>
                      } @else {
                        <div class="h-5 w-5 rounded-full border-2 border-gray-300"></div>
                      }
                    </div>

                    <div class="flex flex-col items-start gap-2 text-right">
                      <div class="flex flex-row-reverse items-center gap-2 text-[14px] font-semibold text-gray-800">
                        <div class="flex flex-row-reverse items-center gap-1 text-gray-500">
                          <span class="font-normal">{{ item.pharmacyId }}</span>
                          <app-id-hash-icon></app-id-hash-icon>
                        </div>

                        <div class="flex flex-row-reverse items-center gap-1">
                          <span>{{ item.ownerName }} ({{ item.pharmacyName }})</span>
                          <app-human-icon></app-human-icon>
                        </div>
                      </div>

                      <div class="flex flex-row-reverse items-center gap-1 text-[13px] text-gray-500">
                        <span>{{ item.location }}</span>
                        <app-location-icon></app-location-icon>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          }
        </div>

        @if (selectedPharmacy(); as pharmacy) {
          <div
            class="bgSelectedColor mt-1 ml-3 flex w-full items-center gap-5 rounded-[10px] border border-gray-200 p-4">
            <div class="shrink-0">
              <div class="bgGreenColor flex h-6 w-6 items-center justify-center rounded-full">
                <app-auto-complete-confirm-icon></app-auto-complete-confirm-icon>
              </div>
            </div>

            <div class="flex flex-col items-start gap-2 text-right">
              <div class="flex flex-row-reverse items-center gap-2 text-[14px] font-semibold text-gray-800">
                <div class="flex flex-row-reverse items-center gap-1 text-gray-500">
                  <span class="font-normal">{{ pharmacy.pharmacyId }}</span>
                  <app-id-hash-icon></app-id-hash-icon>
                </div>

                <div class="flex flex-row-reverse items-center gap-1">
                  <span>{{ pharmacy.ownerName }} ({{ pharmacy.pharmacyName }})</span>
                  <app-human-icon></app-human-icon>
                </div>
              </div>

              <div class="flex flex-row-reverse items-center gap-1 text-[13px] text-gray-500">
                <span>{{ pharmacy.location }}</span>
                <app-location-icon></app-location-icon>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="mt-12 flex w-full justify-end gap-3">
      <button
        type="button"
        (click)="cancel()"
        class="borderTabsColor textTabsColor hover-bg-primary-10 cursor-pointer rounded-[8px] border bg-white px-10 py-2.5 text-[15px] font-bold shadow-sm transition-colors"
        i18n="@@cancelBtn">
        إلغاء
      </button>

      <button
        type="button"
        (click)="goToStatement()"
        [disabled]="!selectedPharmacy() || isNextLoading()"
        class="bgTabsColor flex min-w-[120px] cursor-pointer items-center justify-center rounded-[8px] px-10 py-2.5 text-[15px] font-bold text-white shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50">
        @if (isNextLoading()) {
          <div class="flex items-center gap-2">
            <span i18n="@@loadingBtn">جاري التحميل...</span>
          </div>
        } @else {
          <span i18n="@@nextBtn">التالي</span>
        }
      </button>
    </div>
  </div>
</div>
